module.exports = __webpack_public_path__ + "img/barbucue_img.035355b4.jpg";